<template>
  <div class="ic-section-header">
    <h2 class="ic-section-header__title">{{ title }}</h2>
    <button
      v-if="buttonText"
      v-touch:tap="clickEvent"
      class="ic-section-header__button"
    >
      {{ buttonText }}
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ic-section-header',
  props: {
    clickEvent: {
      type: Function,
      default: () => console.log('clicked section header button')
    },
    buttonText: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>
